import { QueryClient } from '@tanstack/react-query'

// not sure this is being used. 

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,        // 5 min
      refetchOnWindowFocus: false,
    },
  },
})
